(function () {
  if (!window.CfonElements) return;

  class CfonHelpSearch extends CfonElements.Component {
    onConnect() {
      this.form = this.querySelector('form');
      this.onSubmit = (event) => this.handleSubmit(event);
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit);
      }
    }

    onDisconnect() {
      if (this.form && this.onSubmit) {
        this.form.removeEventListener('submit', this.onSubmit);
      }
      this.form = null;
      this.onSubmit = null;
    }

    handleSubmit(event) {
      event.preventDefault();

      const input = this.querySelector('input[type="search"]');
      const query = input ? String(input.value || '').trim() : '';
      if (!query) return;

      const base = String(this.dataset.baseUrl || '')
        .trim()
        .replace(/\/+$/, '');
      const locale = String(this.dataset.locale || 'en-US').trim() || 'en-US';

      location.assign(
        `${base}/${locale}/search/${encodeURIComponent(query)}?page=1`
      );
    }
  }

  CfonElements.define('cfon-help-search', CfonHelpSearch);
})();
